import React, { useCallback, useEffect, useRef, useState } from "react";
import CustomPopup, { CustomPopupProps } from "ui/modal/Popup";
import { ICON_NAMES } from "utils/constant";
import { useClickOutside, useEscapeKey, useOnScroll } from "hooks/hooks";
import { GridColumnProps } from "@progress/kendo-react-grid";

export interface ColumnDropdownProps extends CustomPopupProps {
	onCheckboxChange: (field: string, checked: boolean) => void;
	items: GridColumnProps[];
	forceUpdate?: boolean;
}

const ColumnDropdown: React.FC<ColumnDropdownProps> = React.memo(
	({ items, onCheckboxChange, ...props }) => {
		const colDivRef = useRef<HTMLDivElement>(null);
		const itemsRef = useRef<HTMLDivElement>(null);

		const [showColumnsList, setShowColumnsList] = useState(false);
		const [showColumns, setShowColumns] = useState(false);

		// const handleAnchorClick = useCallback(
		// 	(e: Event) => {
		// 		e.stopPropagation();
		// 		setShowColumns((prev) => !prev);
		// 	},
		// 	[props.anchor]
		// );

		const handleAnchorClick = (e: Event) => {
			e.stopPropagation();
			setShowColumns((prev) => !prev);
		};

		useEffect(() => {
			const anchorElement = props.anchor.current;

			if (anchorElement) {
				anchorElement.addEventListener("click", handleAnchorClick);
			}

			return () => {
				if (anchorElement) {
					anchorElement.removeEventListener("click", handleAnchorClick);
				}
			};
		}, [props.anchor.current, handleAnchorClick, props.forceUpdate]);

		useClickOutside(colDivRef, (el) => {
			if (props.anchor.current && props.anchor.current.contains(el)) {
				return;
			}
			if (itemsRef.current && itemsRef.current.contains(el)) {
				return;
			}
			setShowColumns(false);
		});

		useOnScroll((e) => {
			if (!showColumnsList) {
				setShowColumns(false);
			}
		});

		useEscapeKey(() => {
			setShowColumnsList(false);
			setShowColumns(false);
		});
		return (
			<div>
				<CustomPopup
					onClose={() => setShowColumns(false)}
					show={showColumns}
					anchor={props.anchor}
					anchorAlign={{ vertical: "bottom", horizontal: "center" }}
					popupAlign={{ vertical: "top", horizontal: "center" }}
					offset={{ left: 0, top: 10 }}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							gap: "10px",
							padding: "10px",
							backgroundColor: "#f0f0f0",
						}}
						onMouseEnter={() => setShowColumnsList(true)}
						onMouseLeave={() => setShowColumnsList(false)}
					>
						<div
							ref={colDivRef}
							style={{
								display: "flex",
								gap: "10px",
							}}
						>
							<img
								src={`/icon/${ICON_NAMES.Columns}.svg`}
								alt="Column dropdown"
								style={{ height: 16, width: 16, cursor: "pointer" }}
							/>
							<div style={{ marginRight: "30px" }}> Columns </div>
							<img
								src={`/icon/${ICON_NAMES.Play}.svg`}
								alt="Column dropdown"
								style={{
									height: 16,
									width: 16,
									cursor: "pointer",
								}}
							/>
						</div>

						<CustomPopup
							onClose={() => setShowColumnsList(false)}
							show={showColumnsList}
							anchor={colDivRef}
							anchorAlign={{ vertical: "center", horizontal: "right" }}
							popupAlign={{ vertical: "center", horizontal: "left" }}
							style={{
								marginTop: "210px",
								marginLeft: "8px",
								maxHeight: "96vh",
							}}
						>
							<div
								ref={itemsRef}
								style={{
									display: "flex",
									flexDirection: "column",
									gap: "5px",
									height: "1600px",
									maxHeight: "96vh",
									overflowY: "auto",
								}}
							>
								{items
									.filter(
										(item) =>
											item.field !== "" && item.field !== "productDescription"
									)
									.map((item) => (
										<div
											key={item.field}
											onMouseEnter={(e) => {
												e.currentTarget.style.backgroundColor = "#f0f0f0";
											}}
											onMouseLeave={(e) => {
												e.currentTarget.style.backgroundColor = "transparent";
											}}
											style={{
												display: "flex",
												gap: "3px",
												alignItems: "center",
												cursor: "pointer",
												transition: "background-color 0.2s",
												paddingLeft: "10px",
												paddingRight: "10px",
											}}
											onClick={() =>
												onCheckboxChange(item.field || "", !item.hidden)
											}
										>
											<input type="checkbox" checked={!item.hidden} readOnly />
											{item.title}
										</div>
									))}
							</div>
						</CustomPopup>
					</div>
				</CustomPopup>
			</div>
		);
	}
);

export default ColumnDropdown;
